// extracted by css-extract-rspack-plugin
export default {"main":"ySkrX","resizing":"LaLj3"};